import React from "react";
import SalesSolutions from "../components/SalesSolutions";
import RealEstateOverview from "../components/RealEstateOverview";
import TestimonialSection from "../components/TestimonialSection";
import SellerBuyers from "../components/SellerBuyers";
import Banner from "../components/Banner";
import ContactForm from "../components/ContactForm";

const HomePage = () => {
  const aboutData = {

    heading: "Making Real Estate Simple, Clear, & Accessible for Everyone!",
    content:
      "Buying and selling real estate is super easy with our app. Forget about those big commissions—it's 0% for you! Connect directly with buyers and sellers, skip the realtor hassle, and breeze through paperwork with our simple forms and e-sign options.",


    contentTwo: "Our Journey feature keeps you on track, and if you need help, our friendly team is just a tap away. Join us and see how real estate can be fun!"

  };
  const FAQDATA = [
    {
      heading: "0% Commission House Listings",
      description:
        "Say goodbye to hefty fees and hello to a seamless home-buying experience.Our platform connects you directly with sellers, ensuring you get the best deals without the extra costs.",
    },
    {
      heading: "Professional Coordination for Listing Photos",
      description:
        "Capture your property at its best with ease. Our platform streamlines the process, connecting you with top-tier photographers to showcase your home beautifully—without the hassle.",
    },
    {
      heading:
        "Home Inspection Scheduling Made Easy",
      description:
        "Skip the stress of scheduling! Our seamless system connects you with trusted inspectors, making it easy to book and manage your home inspections with just a few clicks.",
    },
    {
      heading:
        "Effortless Management of Showings & Access",
      description:
        "Stay in control of your property showings. Our platform simplifies scheduling, providing buyers with secure access while keeping you informed every step of the way.",
    },
    {
      heading: "Receive, Counter & Accept",
      description:
        "Negotiate smarter and close deals faster. Our intuitive system allows you to receive, counter, and accept offers seamlessly, ensuring a smooth transaction from start to finish.",
    },
  ];
  return (
    <div>
      <Banner />
      <SellerBuyers FAQDATA={FAQDATA} />
      <SalesSolutions />
      <RealEstateOverview aboutData={aboutData} btnshown={true} />
      <TestimonialSection />
      <ContactForm />
    </div>
  );
};

export default HomePage;
